import React from "react";
import ReactDOM from "react-dom/client";
// Polices auto-hébergées (fonctionne aussi en intranet / hors ligne)
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
// Styles globaux (n'étaient jamais chargés : index.css n'était importé nulle part)
import "./index.css";
import App from "./app/App";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
